"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Feature = _interopRequireDefault(require("./Feature"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeatureCollection =
/** @class */
function () {
  function FeatureCollection(data) {
    data = data || {};
    data.features = data.features || data;

    if (!(0, _utils.isEmpty)(data.features)) {
      this._features = data.features.map(function (featureData) {
        return new _Feature.default(featureData);
      });
    }
  }

  Object.defineProperty(FeatureCollection.prototype, "features", {
    get: function () {
      return this._features;
    },
    enumerable: false,
    configurable: true
  });
  return FeatureCollection;
}();

var _default = FeatureCollection;
exports.default = _default;
module.exports = exports.default;